import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth, selectAuthLoading } from "../../redux/authReducer";
import { Loading } from "../shared/Loading";

/**
 * AuthGuard component - checks authentication status on mount
 * Wraps the application to ensure auth state is initialized
 */
const AuthGuard = ({ children }) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectAuthLoading);

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  if (loading) {
    return <Loading fullScreen text="Initializing..." />;
  }

  return children;
};

export default AuthGuard;
